import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";
import Swal from "sweetalert2";

export class ModContact extends ModuleComponent{
    ready(){
        super.ready();
        this.$contactForm = this.findMember("contact-form");
        this.$contactForm.submit(
            (ev)=>{
                ev.preventDefault();
                let $button = this.findMember("send-form");
                this.$contactForm.checkRestrictions().then(
                    (isOk)=>{
                        if(isOk){
                            if(this.$root.find("textarea[name='comments']").val().length==0){
                                UtilsService.alertEndpointResponse("El campo consulta no tiene datos");
                                return;
                            }
                            $button.prop("disabled",true);
                            GvfService.endpoint("/web/contact/send-contact-form",
                                {form: this.$contactForm.getValues()}).then(
                                (resp)=>{
                                    Swal.fire({
                                        title: GvfService.lang('Solicitud enviada'),
                                        text: resp.message,
                                        icon: 'success',
                                        showCancelButton: false,
                                        confirmButtonColor: '#FF6500',
                                        confirmButtonText: GvfService.lang('cerrar')
                                    }).then(
                                        () => {
                                            location.reload();
                                        }
                                    );
                                }
                            ).catch(
                                (resp)=>{
                                    Swal.fire({
                                        title: GvfService.lang('Error'),
                                        text: resp.message,
                                        icon: 'error',
                                        showCancelButton: false,
                                        confirmButtonColor: '#FF6500',
                                        confirmButtonText: GvfService.lang('cerrar')
                                    });
                                }).finally(
                                ()=>{
                                    $button.prop("disabled",false);
                                }
                            );
                        }
                    }
                );
            }
        );

        this.findMember("send-form").click(
            ()=>{
                this.$contactForm.submit();
            }
        );

    }
}

